import { enableProdMode, importProvidersFrom } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

// import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { ApiInterceptor } from './app/services/api/api.interceptor';
import { en_US, NZ_I18N } from 'ng-zorro-antd/i18n';
import { AppRoutingModule } from './app/app-routing.module';
import { ToastrModule } from 'ngx-toastr';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { providePrimeNG } from 'primeng/config';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import MyPreset from './assets/theme';
import { RolesPermissionsModule } from './app/components/roles-permissions/roles-permissions.module';
import {
  REST_API_URL,
  ROLES_PERMISSIONS_TRANSLATE,
} from 'eco-maestro-roles-permissions';
import { LangService } from './app/services/lang/lang.service';

if (environment.production) {
  enableProdMode();
}

// platformBrowserDynamic().bootstrapModule(AppModule)
//   .catch(err => console.error(err));
bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      AppRoutingModule,
      ToastrModule.forRoot(),
      NzModalModule,
      BrowserAnimationsModule,
      RolesPermissionsModule,
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true,
    },
    { provide: NZ_I18N, useValue: en_US },
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: MyPreset,
        options: {
          darkModeSelector: false, // Disables automatic dark mode
        },
      },
    }),
    { provide: REST_API_URL, useValue: environment.apiSSO },
    LangService,
    {
      provide: ROLES_PERMISSIONS_TRANSLATE,
      useFactory:
        (lang: LangService) =>
        (textId: string, fallback = '') =>
          lang.translate(textId) || fallback || textId,
      deps: [LangService],
    },
  ],
}).catch((err) => console.error(err));
